import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AutoProviderModel from "../../models/auto-provider";

export default class AutoProviderRepository extends BaseRepository {
  static modelClass = AutoProviderModel;
  modelName = "auto-provider";
}
